import axios from "axios";
import router from "../router";
import { createEventosSite } from "./util";
import store from '../../store/index';

const isProd = process.env.NODE_ENV === 'production';


const instance = axios.create({
  baseURL: (isProd) ? 'https://api.comprodonto.com.br/api/' : 'http://127.0.0.1:8000/api/',
  headers: {
    Authorization: localStorage.getItem("token_comprodonto")
      ? `Bearer ${localStorage.getItem("token_comprodonto")}`
      : "",
  },
});

// Add response interceptor to handle token expiration
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear user data and token on 401 Unauthorized
      localStorage.removeItem('token_comprodonto');
      localStorage.removeItem('user');
      
      // Only redirect if not already on the home page
      if (router.currentRoute.path !== '/') {
        router.push('/');
      }
    }
    return Promise.reject(error);
  }
);

instance.interceptors.request.use((config) => {
  if (!config.url.includes('viacep.com.br')) {
    let token = localStorage.getItem("token_comprodonto");
    try {
      // Try to parse the token if it's a JSON string
      token = JSON.parse(token);
    } catch (e) {
      // If it's not a JSON string, use it as is
    }
    config.headers.Authorization = token ? `Bearer ${token}` : '';
  } else {
    delete config.headers.Authorization;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

const GET = (url) =>
  instance
    .get(url || "")
    .then((res) => res.data)
    .then((res) => {
      return res;
    })
    .catch((e) => {
      throw e.response.data;
    });

const POST = (url, params) =>
  instance
    .post(url || "", params)
    .then((res) => res.data)
    .then((res) => {
      return res;
    })
    .catch((e) => {
      throw e.response.data;
    });

const PUT = (url, params) =>
  instance
    .put(url || "", params)
    .then((res) => res.data)
    .then((res) => {
      return res;
    })
    .catch((e) => {
      throw e.response.data;
    });

const DELETE = (url) =>
  instance
    .delete(url || "")
    .then((res) => res.data)
    .then((res) => {
      return res;
    })
    .catch((e) => {
      throw e.response.data;
    });

const LOGIN = (route, payload) =>
  instance
    .post(route, payload)
    .then((res) => res.data)
    .then((res) => {
      return res.token;
    })
    .catch((e) => {
      throw e.response.data;
    });

  router.afterEach(async () => {
    if (router.currentRoute.value.redirectedFrom && router.currentRoute.value.redirectedFrom.path === '/login') {
      store.commit("setModalLogin", {display: true});
      createEventosSite('VISUALIZACAO', 'modal_login'); 
    }

    let queryParams = "";
    if(Object.entries(router.currentRoute.value.query).length > 0){
      queryParams += "?";
      let qtdParams = 0;
      for (var [key, value] of Object.entries(router.currentRoute.value.query)) {
        queryParams+= key + '=' + value;
        if(Object.entries(router.currentRoute.value.query)[qtdParams+1])
          queryParams+="&"
        qtdParams++;
      }
    }

    createEventosSite('VISUALIZACAO', router.currentRoute.value.path+queryParams);
  })

export { GET, POST, PUT, DELETE, LOGIN, instance };
